import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPanoramaView"><Path d="M4.60237 4.09105C2.84359 3.64058 1 4.91114 1 6.80825V17.1911C1 19.0944 2.85383 20.364 4.61485 19.9085C9.62191 18.6136 14.3781 18.6136 19.3852 19.9085C21.1462 20.364 23 19.0944 23 17.1911V6.80825C23 4.91114 21.1564 3.64058 19.3976 4.09105C14.3657 5.37988 9.63433 5.37988 4.60237 4.09105Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPanoramaView;
